// round() is ported from dojo/number — Copyright (c) The JS Foundation, BSD-3-Clause. See ../../LICENSE.
// mds-dojo — dojo/number. format() with en-locale grouping (comma thousands,
// dot decimal). The oracle formats salary with {places: 2} → "1,234.50".

function group(intPart: string): string {
  return intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function format(value: number, options?: any): string {
  options = options || {};
  if (value == null || isNaN(value)) { return ''; }
  const places = typeof options.places === 'number' ? options.places : undefined;

  let str: string;
  if (places != null) {
    str = Math.abs(value).toFixed(places);
  } else {
    // Default dojo pattern "#,##0.###": up to 3 decimals, no trailing zeros.
    str = Math.abs(value).toFixed(3).replace(/\.?0+$/, '');
  }

  const parts = str.split('.');
  parts[0] = group(parts[0]);
  const out = parts.join('.');
  return (value < 0 ? '-' : '') + out;
}

export function parse(str: string, _options?: any): number {
  return parseFloat(String(str).replace(/,/g, ''));
}

// Port of dojo/number.round: nearest value with `places` decimals, away from zero
// on ties; `increment` rounds the next place to the nearest increment/10.
export function round(value: number, places?: number, increment?: number): number {
  const factor = 10 / (increment || 10);
  return Number((factor * +value).toFixed(places)) / factor;
}

const number = { format, parse, round };
export default number;
